export function getView(app_id, automation_id, sync_id) {
  return automation_id
    ? 'Automation'
    : sync_id
    ? 'Sync'
    : app_id
    ? 'App'
    : 'Apps'
}
